import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemoveBackup = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.1603 16.3388L16.4991 17.6777L17.6777 16.4992L1.17852 0L0 1.17851L0.605158 1.78366C0.543933 1.89965 0.509275 2.03183 0.509275 2.1721V15.5054C0.509275 15.9657 0.882375 16.3388 1.34261 16.3388H15.1603ZM13.4936 14.6721H2.17594V8.83877H7.66029L13.4936 14.6721ZM4.32692 5.50543H2.17594V3.35445L4.32692 5.50543ZM17.176 2.1721V13.6406L15.5093 11.9739V8.83877H12.3741L9.04079 5.50543H15.5093V3.00543H6.5408L4.87413 1.33877H16.3426C16.8029 1.33877 17.176 1.71186 17.176 2.1721Z",
		fill: "#D97706"
	})]
});
const ForwardRef = forwardRef(SvgRemoveBackup);
export { ForwardRef as ReactComponent };
